import React from 'react';
import Drawer from '@mui/material/Drawer';

function MobileSort({options, selectState, selectHandleChange}) {

    const [state, setState] = React.useState({
        bottom: false,
      });
    
      const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
    
        setState({ ...state, [anchor]: open });
      };
    
      const handleSelectChange = (value) => {
        selectHandleChange(value);
        setState({ ...state, "bottom": false });
      }

  return (
    <div>
        {['bottom'].map((anchor) => (
        <React.Fragment key={anchor}>
            <button className='bs-btn bs-btn__btn-icon-link lyt-product-list__filter-action' onClick={toggleDrawer(anchor, true)}>
                <span className='bs-btn__icon icon icon-sort'></span>
            </button>
            <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            >
                <div className='bs-sort-by'>
                    <div className='bs-sort-by__title-wrap'>
                        <strong className='bs-sort-by__title'>Sort  By</strong>
                    </div>
                    <div className='bs-sort-by__cont-wrap'>
                        <ul className='bs-sort-by__list-wrap'>
                            {options.map((item, index) => {
                                return  (
                                    <li className='bs-sort-by__list-item' key={index}>
                                        <button className='bs-sort-by__menu-item' onClick={() => {handleSelectChange(item.value)}}>
                                            <span className={`bs-sort-by__menu-icon icon ${item.value === 'l2h' ? 'icon-price-ascending' : item.value === 'h2l' ? 'icon-price-descending' : item.value === 'n2o' ? 'icon-descending' : 'icon-ascending'}`}></span>
                                            <span className='bs-sort-by__menu-text'>{item?.label}</span>
                                        </button>
                                    </li>
                                )
                            })}
                            {/* <li className='bs-sort-by__list-item'>
                                <button className='bs-sort-by__menu-item' onClick={toggleDrawer(anchor, false)}>
                                    <span className='bs-sort-by__menu-icon icon icon-ascending'></span>
                                    <span className='bs-sort-by__menu-text'>Name A to Z</span>
                                </button>
                            </li>
                            <li className='bs-sort-by__list-item'>
                                <button className='bs-sort-by__menu-item' onClick={toggleDrawer(anchor, false)}>
                                    <span className='bs-sort-by__menu-icon icon icon-descending'></span>
                                    <span className='bs-sort-by__menu-text'>Name Z to A</span>
                                </button>
                            </li>
                            <li className='bs-sort-by__list-item'>
                                <button className='bs-sort-by__menu-item' onClick={toggleDrawer(anchor, false)}>
                                    <span className='bs-sort-by__menu-icon icon icon-price-ascending'></span>
                                    <span className='bs-sort-by__menu-text'>Price Low to High</span>
                                </button>
                            </li>
                            <li className='bs-sort-by__list-item'>
                                <button className='bs-sort-by__menu-item' onClick={toggleDrawer(anchor, false)}>
                                    <span className='bs-sort-by__menu-icon icon icon-price-descending'></span>
                                    <span className='bs-sort-by__menu-text'>Price High to Low</span>
                                </button>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </Drawer>
        </React.Fragment>
        ))}
    </div>
  )
}

export default MobileSort